<template>
    <div class="success">
        <Loading v-if="!loadingDone"/>
        <div>
			<p class="title">{{sucTitle}}</p>
			<div class="desc">{{sucDesc}}</div>
            <div class="img">
                <img :src="sucImage" alt="">
            </div>
            <p class="content" v-html="sucContent"></p>
        </div>
    </div>
</template>
<script>
import {Axios} from '@/assets/api/axios'
import Loading from '@/components/Loading'
import notifyIcon from '@/assets/img/msgicon.png'
export default {
    name:'SuccessCase',
    data(){
        return{
			sucTitle:'',          //成功案例标题
			sucDesc:'',            //成功案例描述
            sucImage:'',           //成功案例图片
            sucContent:'',         //成功案例内容
			loadingDone:false,     //数据是否加载完成
			imgList:[]            //后台添加异步加载过来的图片
        }
    },
    created(){
        Axios.get('/index/success/'+this.$route.query.id)
        .then(
            response=>{
                if(response.data.code==200&&response.data.status=="success"){
					this.sucTitle=response.data.data.record_title
					this.sucDesc=response.data.data.record_desc
                    this.sucImage=response.data.data.record_image
					this.sucContent=response.data.data.record_content
					this.loadingDone=true
				}
				this.$nextTick(()=>{
					this.imgList=document.querySelector('.content').querySelectorAll("img")
					this.imgList.forEach((item,index)=>{
						item.style.width='100%'
						item.style.height='auto'
						item.style.display='block'
						item.style.margin="10px auto"
					})
				})
            }
        ).catch(
            error=>{
                this.$swal({
					text:'网络错误 请稍后重试',
					showConfirmButton:false,
					width:'6rem',
					padding:'0.5rem',
					timer:1200,
					imageWidth:50,
					imageHeight:50,
					imageUrl:notifyIcon,
					timerProgressBar: true
				})
            }
		)
	},
    components:{
        Loading
    }
}
</script>

<style scoped lang="scss">
    .success{
        padding:40px;
        width:670px;
        padding-top:128px;
        .img{
            height:120px;
            margin-bottom:40px;
            img{
                width:100%;
                height:100%;
            }
        }
        .title{
            font-size:34px;
            color:#222;
            height:30px;
            font-weight:bold;
            margin-bottom:38px;
            text-align:center;
        }
		.desc{
			font-size:28px;
            color:#999;
			background: #f4f4f4;
			text-align:left;
			text-indent:48px;
			margin-bottom:38px;
			padding:20px;
			line-height:40px;
		}
        .content{
            font-size:28px;
            color:#999;
            line-height:54px;
            text-align:left;
            margin-bottom:50px;
            text-indent:48px;
        }
    }
</style>